module.exports = __webpack_public_path__ + "static/posterImage-2446a7b3bf75eb6675b16a110438bd71.png";